var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 40 40" }, props),
    React.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M27.1 9.6v21.3h7V9.6h-7zm3.5 18.2c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5zM17.6 9.6v21.3h7V9.6h-7zm3.5 18.2c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5z" }),
    React.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M11.4 9L5.2 29.5l6.7 2 6.2-20.4L11.4 9zm-2 18.4c-.8-.2-1.3-1.1-1-1.9.2-.8 1.1-1.3 1.9-1 .8.2 1.3 1.1 1 1.9-.2.8-1.1 1.3-1.9 1z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/products/Archive.svg